export const styles = {
  tableWrapper: {
    width: '100%',
    overflowY: 'auto',
  },
  multiselect: {
    width: '150px',
    paddingLeft: '10px',
    border: '1px solid #E2E2FC',
    height: '40px',
    fontSize: '14px',
    color: '#546b81',
  },
  selectLabel: {
    fontSize: '16px',
    color: '#7F8FA4',
    fontWeight: '600',
    marginRight: '10px',
  },
  multiselectContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  filterContainer: { display: 'flex', gap: '20px', flexDirection: 'column' },
  filterHeader: {
    display: 'flex',
    gap: '15px',
    justifyContent: 'space-between',
  },
  clearFiltersButton: {
    marginLeft: 'auto',
    backgroundColor: 'rgba(127, 143, 164, 1)',
    color: 'white',
    textTransform: 'none',
    fontSize: '14px',
    height: '40px',
  },
}
